<template>
  <div>
    <a-list itemLayout="horizontal" :dataSource="records">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta :description="JSON.stringify(item.args)">
          <a slot="title"
            >Subject: {{ item.subject }}/ Message:{{ item.msg }} / Payout ID:
            <span v-for="(p, pid) in item.payout_id" :key="pid">{{ p }}</span></a
          >
        </a-list-item-meta>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      records: [],
    };
  },
  methods: {
    refresh() {
      this.$http
        .post(this.$store.state.base_url + "/mail_record_r ", { result: false })
        .then((res) => {
          if (res.data.status) {
            this.records = res.data.data;
            console.log(this.records.length);
          }
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>
<style scoped></style>
